import React from 'react';
import ReactDOM from 'react-dom';

import SharingView from './components/SharingView';


export default ({ id, name, description, greeting_text, question_areas, current_questions, target_audience_display }) => {
  const rootElem = $('#app').get(0)

  ReactDOM.render(
    <SharingView id={id} name={name} description={description} />, rootElem);
}
